export enum ParamStrings {
  STEP = "schritt",
  NEW = "neu",
}
